import { Clock, MapPin, CalendarDays } from "lucide-react"
import { vizag2026 } from "../data/vizag2026"
import { vizagAgenda, agendaTime } from "../data/vizagAgenda"

function TimeRange({ start, end }) {
  return (
    <p className="flex flex-wrap items-baseline gap-x-1.5 text-sm font-semibold tabular-nums text-green-800 md:gap-x-1">
      <span className="sr-only">Time in IST: </span>
      <time dateTime={`${vizag2026.isoDate}T${start}:00+05:30`}>{agendaTime(start)}</time>
      <span aria-hidden="true">–</span><span className="sr-only">to</span>
      <time dateTime={`${vizag2026.isoDate}T${end}:00+05:30`}>{agendaTime(end)}</time>
    </p>
  )
}

export function VizagAgenda() {
  return (
    <section id="agenda" aria-labelledby="vizag-agenda-heading" className="bg-gradient-to-b from-green-50 to-white px-3 py-6 sm:px-6 sm:py-8">
      <div className="mx-auto max-w-6xl">
        <div className="mx-auto mb-8 max-w-2xl text-center">
          <img src="/badge/cts-vizag-transparent.png" alt="CTS 2026 Vizag Edition" width="192" height="128" className="mx-auto mb-5 h-auto w-36 max-w-full sm:w-48" />
          <p className="text-xs font-bold uppercase tracking-widest text-green-700">CTS 2026 · Vizag Edition</p>
          <h2 id="vizag-agenda-heading" className="mt-2 text-3xl font-bold tracking-tight text-green-900 sm:text-4xl">Event Agenda</h2>
          <div className="mt-5 flex flex-col items-center justify-center gap-3 text-sm text-green-800 sm:flex-row sm:flex-wrap">
            <p className="inline-flex items-center gap-2"><CalendarDays className="h-4 w-4 shrink-0" aria-hidden="true" /><time dateTime={vizag2026.isoDate}>{vizag2026.date}</time></p>
            <p className="inline-flex items-center gap-2"><MapPin className="h-4 w-4 shrink-0" aria-hidden="true" />{vizag2026.venue}</p>
          </div>
          <p className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-green-700"><Clock className="h-4 w-4 shrink-0" aria-hidden="true" />09:00 AM – 04:20 PM · All times IST</p>
        </div>

        <nav aria-label="Jump to agenda session" className="mb-6 flex flex-wrap justify-center gap-2">
          {vizagAgenda.filter((group) => !group.break).map((group) => (
            <button key={group.id} type="button" onClick={() => {
              const target = document.getElementById(`agenda-${group.id}`)
              target?.scrollIntoView({ block: "start", behavior: "auto" })
              target?.focus({ preventScroll: true })
            }} className="inline-flex min-h-[44px] items-center rounded-full border border-green-200 bg-white px-4 py-2 text-sm font-semibold text-green-800 transition hover:border-green-500 hover:bg-green-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-green-700">{group.title}</button>
          ))}
        </nav>

        <div className="overflow-hidden rounded-2xl border border-green-200 bg-white shadow-sm sm:rounded-3xl">
          <div aria-hidden="true" className="hidden grid-cols-[12rem_minmax(0,1fr)_10rem] gap-5 bg-green-900 px-6 py-4 text-sm font-semibold text-white md:grid lg:grid-cols-[12rem_minmax(0,1fr)_12rem]">
            <span>Time (IST)</span><span>Topic</span><span>Presenter(s)</span>
          </div>
          {vizagAgenda.map((group) => (
            <div key={group.id} id={`agenda-${group.id}`} tabIndex={-1} className="scroll-mt-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-green-700">
              {!group.break && <h3 className="border-y border-green-100 bg-green-50 px-4 py-3 text-sm font-bold uppercase tracking-wide text-green-900 sm:px-6">{group.title}</h3>}
              <ol className="divide-y divide-green-100">
                {group.entries.map((entry) => (
                  <li key={entry.start} className={`grid min-w-0 gap-2 px-4 py-5 sm:px-6 md:grid-cols-[12rem_minmax(0,1fr)_10rem] md:items-start md:gap-5 lg:grid-cols-[12rem_minmax(0,1fr)_12rem] ${group.break || entry.break ? "bg-amber-50/70" : "bg-white"}`}>
                    <TimeRange start={entry.start} end={entry.end} />
                    <p className="min-w-0 break-words text-base font-semibold leading-relaxed text-green-950">{entry.title}</p>
                    {entry.presenters && <p className="min-w-0 break-words text-sm leading-relaxed text-green-700"><span className="sr-only">Presenter(s): </span>{entry.presenters}</p>}
                  </li>
                ))}
              </ol>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
